import { configStore } from "../../../stores/config.store";
import { vratKodFarbyPodlaTypu } from "../../../helpers/config";
import { vratHladanyVyraz } from "../../../api/search";
import get from "get-value";
import { get as get_store } from "svelte/store";

export function volbaTypuVyhladavania(event) {
  let vyhladavanieId;
  // ziskam ID typu vyhladavanie
  if (event.target.hasAttribute("vyhladavanie-id")) {
    vyhladavanieId = event.target.getAttribute("vyhladavanie-id");
  } else {
    vyhladavanieId = event.target.closest("li").getAttribute("vyhladavanie-id");
  }
  // z konfigu si vytiahnem dane vyhladavanie
  const vyhladavanie = get(
    get_store(configStore),
    "vyhladavania.typy",
    []
  ).find((v) => v.id === parseInt(vyhladavanieId));

  // nahradim placeholder v inpute vyhladavanie
  document
    .getElementById("search")
    .setAttribute("placeholder", vyhladavanie.placeholder);
  document
    .getElementById("search")
    .setAttribute("vyhladavanie_id", vyhladavanie.id);
  document.getElementById("search").focus();

  // zmenim hlavicku vyberu typu vyhladavania
  const vyberVyhladavania = document.getElementById("vyberVyhladavania");
  vyberVyhladavania.className = vyberVyhladavania.className.replace(
    /color__bg--[0-9]{3}/,
    `color__bg--${vyhladavanie.kod_farby}`
  );
  const vyberVyhladavaniaKod = vyhladavanie.kod_ikonky;
  vyberVyhladavania.querySelector(".select__text").innerHTML =
    vyhladavanie.nazov;
}

export async function vyhladajVyraz(keyword) {
  const idVyhladavania = document
    .getElementById("search")
    .getAttribute("vyhladavanie_id");
  const vyhladavanie = get(
    get_store(configStore),
    "vyhladavania.typy",
    []
  ).find((v) => v.id === parseInt(idVyhladavania));

  const response = await vratHladanyVyraz(vyhladavanie.id, keyword);

  return get(response, "data");
}

export function createLabel(item) {
  /* if ( undefined === item ) {
      return false;
    } */
  return `<span class="color__text--${vratKodFarbyPodlaTypu(item.typ)}">${
    item.title
  }</span><span class="popis">${item.label}</span>`;
}
